import React from "react";

const InputTextarea = ({
    name,
    value,
    label,
    onChange,
    placeholder,
    disabled,
    maxLength,
    onBlur,
    error,
    success,
}) => {
    return (
        <div className={`input-container ${error ? "error" : ""} ${success ? "success" : ""}`}>
            {label && <label htmlFor={name}>{label}</label>}
            <textarea
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                onBlur={onBlur}
                className="form-control"
            />
        </div>
    );
};

export default InputTextarea;
